import type {
  Contest as APIContest,
  PayoutSchedule,
  Commissioner as APICommissioner,
} from '@betterpool/api-types/contests-service';

import type { ContestEntitySourceV2 } from '~/services/contests/contests-v2.service.api';

import type { ContestSource } from '../enums/contest-source.enum';

// eslint-disable-next-line
enum AdditionalPayoutType {
  GUARANTEED_PLUS = 'guaranteed-plus',
}

interface Commissioner extends APICommissioner {
  displayName?: string;
}

interface Contest extends Omit<APIContest, 'start_date' | 'end_date' | 'commissioner' | 'entries'> {
  start_date: Date;
  /** Wire `entries` plus the parser-normalized stake-visible count. */
  entries: APIContest['entries'] & { user_any_stake?: number };
  end_date: Date;
  commissioner: Commissioner;
  marketplace_enabled?: boolean;
  // TODO(EDGE-16286): move to @betterpool/api-types
  /** Number of people who you are following that are in the contest */
  following?: number;
  /** Number of people who follows you that are in the contest (only if following is 0) */
  followed?: number;
  manage_entrants?: boolean;
  entrants_count?: number;

  // Payout settings
  additional_payout_settings?: {
    deadline: Date;
    enabled: boolean;
    message: string;
    originalPrizePool: number;
    originalPrizePoolInDollars: number;
    type: AdditionalPayoutType;
  };

  payout_schedule?: PayoutSchedule[];

  // EO SplashBoard specific
  source?: ContestSource;
  entitySource?: ContestEntitySourceV2;
  game_center_url?: string;
  gameCenterUrl?: string; // Because fuck consistency (different services use different cases)...
  manage_contest_url?: string;
  restart_url?: string;
  share_url?: string;
  contest_type_alt_text?: string;
  contestTypeAltText?: string;
  lock_date?: Date;
}

export type { Contest, Commissioner };
export { AdditionalPayoutType };
